<template>
  <div>
    <el-tree
            class="global-el-tree"
            :data="data"
            check-strictly
            :show-checkbox="multiple"
            :props="props"
            node-key="id"
            ref="tree"
            :empty-text="emptyText"
            :filter-node-method="filterNodeMethod"
            :expand-on-click-node="false"
            @check-change="checkChange"
    >
      <div class="custom-tree-node" slot-scope="{ node, data }">

        <span>{{ node.label }}</span>

        <Radio  style="float:right;"
                v-if="!multiple && !node.disabled"
                @on-change="handleRadioChange(data)"
                :value="node.checked"
        ></Radio>
        <template v-if="multiple">
          <Dropdown
                  placement="bottom-end"
                  @on-click="handleDropDownClick(data, arguments)"
                  trigger="click"
                  style="float: right;"
          >
            <span>
              <Icon type="ios-more" size="20"></Icon>
            </span>
            <DropdownMenu slot="list">
              <DropdownItem :name="1">全选</DropdownItem>
              <DropdownItem :name="2">选中直属下级</DropdownItem>
              <DropdownItem :name="3">选中所有下级</DropdownItem>
              <DropdownItem :name="4">取消选择</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </template>
      </div>
    </el-tree>
  </div>

</template>

<script>
import { typeOf } from "@/utils/tools";
const getCheckedNodeKey = data => {
  const checkedNodeKey = [];
  const _getCheckedNodeKey = node => {
    if (typeOf(node) === "object") {
      for (let key in node) {
        if (key === "id") {
          checkedNodeKey.push({
            id: node.id
          });
        }
        if (key === "children" && node[key].length) {
          _getCheckedNodeKey(node[key]);
        }
      }
    } else {
      node.forEach(item => {
        checkedNodeKey.push({
          id: item.id
        });
        if (item.children && item.children.length) {
          _getCheckedNodeKey(item.children);
        }
      });
    }
  };
  _getCheckedNodeKey(data);
  return checkedNodeKey;
};
export default {
  name: "my-tree",
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    emptyText: {
      type: String
    },
    props: {
      default() {
        return {
          children: "children",
          label: "label",
          disabled: "disabled"
        };
      }
    },
    data: {
      type: Array
    },
    filterNodeMethod: Function
    // defaultProps
  },
  mounted() {},
  data() {
    return {
      // treeData: [
      //   {
      //     id: 1,
      //     title: "一级 1",
      //     children: [
      //       {
      //         id: 4,
      //         title: "二级 1-1",
      //         children: [
      //           {
      //             id: 9,
      //             title: "三级 1-1-1"
      //           },
      //           {
      //             id: 10,
      //             title: "三级 1-1-2"
      //           }
      //         ]
      //       }
      //     ]
      //   },
      //   {
      //     id: 2,
      //     title: "一级 2",
      //     children: [
      //       {
      //         id: 5,
      //         title: "二级 2-1"
      //       },
      //       {
      //         id: 6,
      //         title: "二级 2-2"
      //       }
      //     ]
      //   },
      //   {
      //     id: 3,
      //     title: "一级 3",
      //     children: [
      //       {
      //         id: 7,
      //         title: "二级 3-1"
      //       },
      //       {
      //         id: 8,
      //         title: "二级 3-2"
      //       }
      //     ]
      //   }
      // ],
    };
  },
  methods: {
    handleRadioChange(data) {
      let { id } = data;
      this.$refs.tree.setCheckedNodes([{ id }]);
    },

    handleDropDownClick(data, arg) {
      const name = arg[0];
      if (name === 1) {
        //全选
        this.selectAll(data);
      }
      if (name === 2) {
        //选中直属下级
        this.selectChild(data);
      }
      if (name === 3) {
        //选中所有下级
        this.selectAllChild(data);
      }
      if (name === 4) {
        //取消全选
        this.unSelectAll(data);
      }
    },
    selectAll(data) {
      const checkedNodeKey = getCheckedNodeKey(data);
      this._setCheckedNodes(checkedNodeKey);
    },
    selectChild(data) {
      const checkedNodeKey = [];
      if (data.children && data.children.length) {
        data.children.forEach(item => {
          checkedNodeKey.push({
            id: item.id
          });
        });
        this._setCheckedNodes(checkedNodeKey);
      }
    },
    selectAllChild(data) {
      if (data.children && data.children.length) {
        this.selectAll(data.children);
      }
    },
    unSelectAll(data) {
      const checkedData = getCheckedNodeKey(data);
      const selectedData = this.getCheckedNodes();
      checkedData.forEach(item => {
        const selectedDataIds = selectedData.map(item => item.id);
        let _index = selectedDataIds.indexOf(item.id);
        if (_index !== -1) {
          selectedData.splice(_index, 1);
        }
      });
      this.$refs.tree.setCheckedNodes(selectedData);
    },
    _setCheckedNodes(checkedData = []) {
      const selectedData = this.getCheckedNodes();
      const selectedDataIds = checkedData.map(item => item.id);
      selectedData.forEach(item => {
        if (!selectedDataIds.includes(item.id)) {
          checkedData.push(item);
        }
      });
      this.$refs.tree.setCheckedNodes(checkedData);
    },
    setCheckedNodes(checkedData = []) {
      console.log(checkedData);
      this.$refs.tree.setCheckedNodes(checkedData);
    },
    checkChange() {
      //节点状态发生改变时触发
      const checkedNode = this.getCheckedNodes();
      this.$emit("on-change", checkedNode);
    },
    getCheckedNodes() {
      return this.$refs.tree.getCheckedNodes();
    },
    filter(val) {
      val = val.trim();
      this.$refs.tree.filter(val);
    }
  },
}
</script>

<style scoped>

</style>
